import * as yup from "yup";

const maxHours = 24;

export const getValidationSchema = () => {
  const schema = yup.object().shape({
    selectedWorker: yup
      .object()
      .shape({
        workerId: yup.string().required(),
      })
      .required()
      .nullable(false),
    // districtId: yup.string().required(),
    // buildingId: yup.string().required(),
    records: yup.array().of(
      yup.object().shape({
        day2: yup.number().typeError("Invalid input").min(0).max(24),
        day3: yup.number().typeError("Invalid input").min(0).max(24),
        day4: yup.number().typeError("Invalid input").min(0).max(24),
        day1: yup.number().typeError("Invalid input").min(0).max(24),
        day5: yup.number().typeError("Invalid input").min(0).max(24),
        day6: yup.number().typeError("Invalid input").min(0).max(24),
        day7: yup.number().typeError("Invalid input").min(0).max(24),
        details: yup.string().required()
      })
    ),
    weekTotal: yup
      .object()
      .shape({
        day1: yup.object().shape({
          hours: yup.number().min(0).max(maxHours),
        }),
        day2: yup.object().shape({
          hours: yup.number().min(0).max(maxHours),
        }),
        day3: yup.object().shape({
          hours: yup.number().min(0).max(maxHours),
        }),
        day4: yup.object().shape({
          hours: yup.number().min(0).max(maxHours),
        }),
        day5: yup.object().shape({
          hours: yup.number().min(0).max(maxHours),
        }),
        day6: yup.object().shape({
          hours: yup.number().min(0).max(maxHours),
        }),
        day7: yup.object().shape({
          hours: yup.number().min(0).max(maxHours),
        }),
      })
      .required(),
    // totalHours: yup
    //   .number()
    //   .default(0)
    //   .moreThan(0, `Minimum hours should be greater than 0`),
  });

  return schema;
};

(function () {
  const schema = getValidationSchema();
  schema
    .isValid({
      records: [
        {
          family: "Ok",
          group: "Project",
          //details: "",
          freeForm: "Ok",
          showFreeForm: false,
          day1: "0",
          day2: "0",
          day3: "2",
          day4: "0",
          day5: "0",
          day6: "0",
          day7: "1",
        },
      ],
    })
    .then((res) => console.log("Validation", res))
    .catch((e) => console.error("Validation", e));
})();
